var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 244,
    viewBox: "0 0 191 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 14.3257C68.5 14.3257 59.4 7.0257 72.1 7.0257C84.8 7.0257 77.6 3.4257 81.2 1.5257C84.8 -0.374303 93.5 0.425697 95.5 3.4257C98.4 7.7257 101.3 8.8257 104.9 8.8257C108.5 8.8257 114 12.5257 110.4 14.3257C106.8 16.1257 101.3 14.3257 95.8 18.0257C90.3 21.7257 83 19.8257 83 19.8257C83 19.8257 75.7 18.0257 70.2 21.6257C64.7 25.3257 68.4 14.3257 68.4 14.3257H68.5Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3999 19.9258C78.3999 19.9258 77.3 28.3258 80.8 37.5258C84.6 47.5258 86 62.8258 85.6 59.4258",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2999 16.5254C99.2999 16.5254 100.7 29.8254 96.8999 41.3254C93.0999 52.8254 94.4999 60.8254 94.4999 60.8254",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4 75.826C88 71.026 85.3 61.526 84.6 56.026L88.9 59.826L93.7 53.126C93.7 53.126 95.5 67.226 96 74.626C96.1 76.226 95 77.726 93.5 78.126C91.8 78.526 90 77.526 89.5 75.826H89.4Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1999 10.3258C92.1999 10.3258 87.7999 8.12579 83.3999 9.92579",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.8 15.0261C119.8 15.0261 115.9 4.0261 126.8 10.7261C134.7 15.6261 133.4 10.5261 137.4 10.9261C141.4 11.3261 148.4 16.4261 148.5 20.1261C148.6 25.2261 150.5 27.7261 153.6 29.7261C156.7 31.7261 159.4 37.6261 155.3 37.2261C151.2 36.8261 147.6 32.4261 141 32.6261C134.4 32.8261 129.2 27.4261 129.2 27.4261C129.2 27.4261 124 22.0261 117.4 22.2261C110.8 22.4261 119.7 15.0261 119.7 15.0261H119.8Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.3 25.0264C125.3 25.0264 119.9 31.6264 118 41.2264C115.9 51.6264 109 65.4264 110.4 62.3264",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.8 33.3262C144.8 33.3262 138.9 45.4262 129.7 53.0262C120.4 60.7262 117.3 68.3262 117.3 68.3262",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 78.3264C106.3 73.4264 109 64.0264 111.3 59.0264L112.9 64.5264L120.5 61.4264C120.5 61.4264 114.6 74.3264 111 80.8264C110.2 82.2264 108.6 82.9264 107 82.4264C105.3 81.8264 104.3 80.1264 104.8 78.3264H104.9Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M135.8 25.1266C138.6 26.4266 141.9 26.5266 142.1 24.2266",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M180.2 79.3255C180.2 79.3255 191.2 83.3255 184.5 72.4255C179.7 64.5255 184.8 65.8255 184.5 61.8255C184.2 57.8255 179.1 50.7255 175.4 50.6255C170.3 50.4255 167.8 48.5255 165.9 45.4255C164 42.3255 158 39.5255 158.4 43.6255C158.7 47.7255 163.2 51.4255 162.9 58.0255C162.6 64.6255 168 69.9255 168 69.9255C168 69.9255 173.4 75.2255 173.1 81.8255C172.8 88.4255 180.3 79.6255 180.3 79.6255L180.2 79.3255Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.3 73.7256C170.3 73.7256 163.7 79.0256 154 80.8256C143.5 82.8256 129.7 89.5256 132.8 88.1256",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.2 54.126C162.2 54.126 150.1 59.826 142.3 69.026C134.5 78.226 126.9 81.226 126.9 81.226",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.8 93.526C121.7 92.226 131.2 89.626 136.2 87.326L130.7 85.626L133.9 78.126C133.9 78.126 121 83.926 114.4 87.326C113 88.126 112.3 89.726 112.8 91.326C113.3 93.026 115.1 94.026 116.8 93.526Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.2 56.9258C171.2 56.9258 175.4 59.5258 176.1 64.2258",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.1 82.3262L94.4 96.7262",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.1 91.626L95 96.526",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9 110.226C89.6 105.926 92.2 101.526 94.7 97.026L93.4 78.126",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3 159.325C48.1 157.625 49.9 155.825 51.7 154.025",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 138.626L26.5 129.426C26.5 129.426 33.7 122.626 37.4 121.626C43.5 119.926 45.2 123.626 45.2 123.626C45.2 123.626 44.9 113.726 43.2 109.326C41.5 104.926 47 99.4258 54.1 99.4258C61.2 99.4258 64.3 106.926 64.3 110.326C64.3 113.726 68.7 103.526 72.1 102.126C75.5 100.726 77.6 106.526 84.7 108.226C91.8 109.926 80.9 123.226 80.9 123.226C80.9 123.226 94.9 122.526 97.6 135.826C97.6 135.826 91.5 136.826 87.7 140.226C83.9 143.626 77.1 146.326 70.6 139.926C70.6 139.926 75.4 150.526 66.5 157.326C66.5 157.326 56.3 158.726 50.8 153.526C45.3 148.426 54.9 139.926 54.9 139.926C54.9 139.926 30.3 147.726 28.3 138.526L28.5 138.626Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 130.926C67 129.726 67.2 126.326 65 124.726C62.8 123.226 60 121.926 57.6 122.826C52.8 124.526 56.6 129.626 60 131.326C61.4 132.026 63 131.626 64.6 130.926H64.5Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67 127.325C67 127.325 71.4 127.325 74.5 121.525",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2 123.726C64.2 123.726 68.1 122.926 70.8 115.426",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 122.926C57.5 122.926 54.1 116.826 55.8 113.326",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9 155.926L47.8999 160.926C47.8999 160.926 47.7 170.826 45.8 174.226C42.7 179.826 38.8 178.426 38.8 178.426C38.8 178.426 46.1 185.126 50.5 187.026C54.9 188.926 54.8999 196.626 49.8999 201.726C44.8999 206.826 37.4 203.726 34.9 201.326C32.4 198.926 36.7 209.226 35.2 212.626C33.7 216.026 28.2 213.426 22 217.326C15.8 221.226 13.9 204.126 13.9 204.126C13.9 204.126 4.59995 214.626 -6.80005 207.226C-6.80005 207.226 -3.20005 202.126 -3.00005 197.026C-2.80005 191.926 -4.86374e-05 185.226 9.19995 185.126C9.19995 185.126 -1.70005 181.126 -0.300049 170.026C-0.300049 170.026 5.89996 161.726 13.4 161.426C20.9 161.126 20.3 173.926 20.3 173.926C20.3 173.926 31.9 150.926 39.9 155.926Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0999 186.926C19.1999 189.526 21.4999 192.126 24.1999 191.526C26.7999 191.026 29.6999 189.926 30.7999 187.626C32.8999 183.026 26.6999 182.126 22.9999 183.326C21.5999 183.826 20.6999 185.326 20.0999 186.926Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8999 191.326C20.8999 191.326 17.7999 194.526 19.7999 200.726",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 191.826C25.5 191.826 23.4 195.126 26.8 202.326",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7 187.626C30.7 187.626 37.5 189.526 38.7 193.126",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 88.2261C12.9 88.2261 1.80001 84.7261 13.7 80.1261C22.4 76.7261 17.5 74.7261 20.2 71.7261C22.9 68.7261 31.2 66.2261 34.2 68.3261C38.4 71.3261 41.5 71.2261 45 69.9261C48.4 68.6261 54.8 70.0261 52.1 73.0261C49.4 76.0261 43.6 76.3261 39.8 81.7261C36 87.1261 28.5 88.0261 28.5 88.0261C28.5 88.0261 21 88.9261 17.2 94.3261C13.4 99.7261 12.9 88.1261 12.9 88.1261V88.2261Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 89.8262C24.2 89.8262 26.2 98.0262 32.8 105.426C39.9 113.326 46.8 127.126 45.1 124.126",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 79.126C42.5 79.126 47.8 89.326 49 100.426",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 75.9265C33.6 75.9265 28.7 75.4265 25.2 78.7265",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M-10.8 143.326C-10.8 143.326 -2.50005 145.226 6.99995 142.726C17.3 140.026 31.5 138.626 28.1 138.726",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 122.126C-12 122.126 1.4 122.126 12.4 127.026C18.4 129.726 23.6 130.826 27.1 131.126",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3 193.325C93.3 193.325 100 202.925 100.8 190.125C101.4 180.825 104.8 184.925 106.9 181.425C109 177.925 108.8 169.225 105.9 167.025C101.8 163.925 100.9 160.925 101.1 157.225C101.3 153.525 98.1 147.925 96 151.425C93.9 154.925 95.4 160.525 91.4 165.725C87.4 170.925 88.7 178.325 88.7 178.325C88.7 178.325 90 185.725 86 190.925C82 196.125 93.2 193.225 93.2 193.225L93.3 193.325Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3999 183.025C88.3999 183.025 79.8999 183.525 70.9999 179.525C61.2999 175.125 46.0999 172.725 49.4999 173.325",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1 162.325C93.1 162.325 79.9 160.025 68.2 163.025C56.5 166.025 48.6 164.125 48.6 164.125",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8 169.925C98.8 169.925 100.7 174.425 98.6 178.725",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8 237.226C60.8 237.226 62.1 248.826 68.9 238.026C73.9 230.126 74.9 235.326 78.4 233.226C81.9 231.126 85.9 223.526 84.5 220.126C82.4 215.426 83.1 212.326 85 209.226C87 206.126 86.8 199.526 83.3 201.626C79.8 203.726 78.4 209.326 72.4 212.026C66.4 214.726 64 221.826 64 221.826C64 221.826 61.6 228.926 55.6 231.626C49.6 234.326 60.8 237.126 60.8 237.126V237.226Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4 225.926C61.4 225.926 55.9 222.226 49.6 214.726C47.4 212.126 44.1 207.726 41.9 204.426",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5001 210.026C75.5001 210.026 65.0001 201.626 53.3001 198.726C53.1001 198.726 52.9001 198.726 52.7001 198.626",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9 219.426C76.9 219.426 76.4 224.326 72.5 227.126",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M178.8 133.326C178.8 133.326 187.6 141.026 185.4 128.426C183.8 119.226 188 122.426 189.2 118.526C190.4 114.626 188.2 106.226 184.9 104.826C180.2 102.726 178.6 100.026 178 96.426C177.4 92.826 172.8 88.026 171.7 92.026C170.5 95.926 173.3 101.026 170.6 107.026C167.9 113.026 171 119.926 171 119.926C171 119.926 174.1 126.826 171.4 132.826C168.7 138.826 178.9 133.326 178.9 133.326H178.8Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M171.6 124.526C171.6 124.526 163.5 127.026 153.8 125.226C143.3 123.226 128 124.526 131.4 124.326",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M171.2 103.326C171.2 103.326 157.8 104.226 147.2 109.926C136.6 115.626 128.4 115.626 128.4 115.626",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 123.326C119.5 123.926 129.3 124.926 134.8 124.626L130.3 121.026L136 115.226C136 115.226 121.8 115.926 114.4 116.726C112.8 116.926 111.5 118.226 111.4 119.826C111.3 121.626 112.6 123.126 114.3 123.426L114.5 123.326Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M178.6 109.226C178.6 109.226 181.6 113.226 180.5 117.826",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 119.826C111.6 119.826 96.2 120.226 86.3 117.126",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFooter);
export default __webpack_public_path__ + "static/media/bg-footer.5cf837c9377297d472f017cafead5d63.svg";
export { ForwardRef as ReactComponent };